import React from 'react';

const TransformationsSection = () => {
  // Array com as fotos de transformação do cliente
  const transformationImages = [
    '/images/transform-1.jpg',
    '/images/transform-2.jpg',
    '/images/transform-3.jpg',
    '/images/transform-4.jpg',
    '/images/transform-5.jpg',
    '/images/transform-6.jpg',
    '/images/transform-7.jpg',
    '/images/transform-8.jpg',
    '/images/transform-9.jpg',
  ];

  return (
    <section className="bg-white py-16">
      <div className="container mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-12 scroll-reveal">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8">
            <span className="text-[#fff301]">TRANSFORMAÇÕES</span>
            <span className="text-[#fff301]"> – </span>
            <span className="text-[#fff301]">ANTES E DEPOIS</span>
          </h2>
          
          <p className="text-xl md:text-2xl lg:text-3xl font-bold text-black italic mb-8 max-w-4xl mx-auto">
            "O SEGREDO PARA EMAGRECER NÃO É SOFRER, É MUDAR O MÉTODO.<br />
            A TUA SAÚDE AGRADECE."
          </p>
          
          <div className="max-w-3xl mx-auto space-y-2">
            <p className="text-black text-base md:text-lg">
              Escolhe o teu plano com o Bruno e começa a tua jornada de perda de peso e saúde
            </p>
            <p className="text-gray-600 text-sm md:text-base">
              Planos para resultados reais e duradouros, desenhados por um personal trainer e<br />
              nutricionistas certificados, adaptados ao teu ritmo e objetivos.
            </p>
          </div>
        </div>

        {/* Grid de Transformações - 3 colunas no desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {transformationImages.map((image, index) => (
            <div 
              key={index}
              className="rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <img
                src={image}
                alt={`Transformação ${index + 1}`}
                className="w-full h-auto object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TransformationsSection;
